import React, { Fragment, useEffect, useState }  from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import ReactDOM from 'react-dom';

import { useAuth } from '../../Context/Context';

import SideNav from '../../Components/SideNav';
import FormularioAgregar from '../../Components/FormularioAgregar';
import FormularioEditar from '../../Components/FormularioEditar';
import Loader from '../../Components/Loader';
import View from './View';

import profesoresHelper from '../../Helpers/Profesores';
import useStorage from '../../Hooks/useStorage';
import Swal from 'sweetalert2';


const Profesores = props => {
    const { editar, setEditar, index, data, setData, tipo } = useAuth();

    const [flag, setFlag] = useState(false);
    const [profesores, setProfesores] = useState({
        tipo: 0,
        archivo:"archivo",
        ...editar
    });
    const [urlProfesor, setUrlProfesor] = useState("");
    const [materias, setMaterias] = useState("");
    const [file, setFile] = useState({});

    // uso de hooks para agregar imagen a google storage
    const [consulta, setConsulta] = useState("");
    let [ response ] = useStorage(consulta);

    useEffect(() => {
        if (!response) {
            setFlag(false);
    
            setProfesores({
                ...profesores,
                ...editar
            });

            setMaterias(profesores.materias)
            
            setTimeout(() => {
                setFlag(true);
            }, 100);
    
            setTimeout(() => {
                let ckedittor_contenedor = document.getElementById("ckedittor_contenedor_editar");
                ReactDOM.render(
                    <CKEditor
                        data={editar.materias}
                        editor={ ClassicEditor }
                        onChange={ ( event, editor ) => {
                            let copiaData = {...data};
    
                            const dataEditor = editor.getData();
                            setMaterias(dataEditor);
    
                            if (tipo === 0) {
                                // directivo
                                copiaData.directivo[index]["materias"] = dataEditor
                                setData(copiaData);
                            } else if (tipo === 1) {
                                // coordinador
                                copiaData.coordinador[index]["materias"] = dataEditor
                                setData(copiaData);
                            } else {
                                // profesor
                                copiaData.profesor[index]["materias"] = dataEditor
                                setData(copiaData);
                            }
                        } }
                    />,
                    ckedittor_contenedor
                );
            }, 200);
        } else {
            if (response.action === 'agregar') {
                agregar(response.url);
            } else if (response.action === 'eliminar') {
                eliminar();
            } else if (response.action === 'actualizar') {
                subirArchivoActualizado();
            } else if (response.action === 'agregarActualizado') {
                actualizar(response.url);
            } else {
                // error
            }
        }
    },[editar, response]);


    const leerDato = e => {
        let copiaData = {...data};

        setProfesores({
            ...profesores,
            [e.target.name]: e.target.value
        });

        if (tipo === 0) {
            // directivo
            copiaData.directivo[index][e.target.name] = e.target.value
            setData(copiaData);
        } else if (tipo === 1) {
            // coordinador
            copiaData.coordinador[index][e.target.name] = e.target.value
            setData(copiaData);
        } else {
            // profesor
            copiaData.profesor[index][e.target.name] = e.target.value
            setData(copiaData);
        }
    }

    const agregarFoto = e => {
        setFile(e.target.files[0]);
        setUrlProfesor(profesores.archivo);

        let copiaData = {...data};
        let fileReader = new FileReader();
        fileReader.addEventListener('load', function(evt){
            setProfesores({
                ...profesores,
                archivo: fileReader.result
            });

            if (tipo === 0) {
                // directivo
                copiaData.directivo[index]["archivo"] = fileReader.result
                setData(copiaData);
            } else if (tipo === 1) {
                // coordinador
                copiaData.coordinador[index]["archivo"] = fileReader.result
                setData(copiaData);
            } else {
                // profesor
                copiaData.profesor[index]["archivo"] = fileReader.result
                setData(copiaData);
            }
        });
        fileReader.readAsDataURL(e.target.files[0]);
    }

    const actualizarFoto = e => {
        setFile(e.target.files[0]);

        // visualizar la imagen
        let fileReader = new FileReader();
        fileReader.addEventListener('load', function(evt){
            setEditar({
                ...editar,
                archivo: fileReader.result
            });
        });
        fileReader.readAsDataURL(e.target.files[0]);
    }

    const subirArchivo = e => {
        e.preventDefault();

        setConsulta({consulta:"agregar", name:profesores.nombre, folder:"profesores/", file, url:"/profesores"});
    }

    const agregar = url => {
        let body = {
            ...editar,
            ...profesores,
            archivo: url
        }

        profesoresHelper.agregarProfesor(body);
    }

    const actualizar = url => {
        let copiaProfesor = {
            ...profesores,
            archivo: url,
            materias: materias
        };

        profesoresHelper.editarProfesor(copiaProfesor, profesores._id);
    }

    const actualizarArchivo = e => {
        e.preventDefault();

        if (urlProfesor === "") {
            return Swal.fire({
                icon: "question",
                title: '¿Esta seguro que desea modificar el campo?',
                showDenyButton: true,
                showCancelButton: true,
                confirmButtonText: 'Si',
                denyButtonText: `No`,
            }).then(async (result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    actualizar(profesores.archivo);
                } else if (result.isDenied) {
                    Swal.fire(
                        'Modificación cancelada',
                        'El campo quedo intacto' ,
                        'succes'
                    )
                }
            })
        }

        setConsulta({consulta:"actualizar", url:"/profesores", urlFile:urlProfesor});
    }

    const subirArchivoActualizado = () => {

        setConsulta({consulta:"agregarActualizado", name:profesores.nombre, folder:"profesores/", file});
    }

    const eliminar = () => {
        profesoresHelper.eliminarProfesor(profesores._id);
    }

    const eliminarArchivo = () => {
        setConsulta({consulta:"eliminar", url:"/profesores", urlFile:profesores.archivo});
    }


    return (
        <Fragment>
            <SideNav />
            <div className='row'>
                <FormularioAgregar>
                    <p className='titulo_1_admin'>Profesores</p>
                    
                    <form onSubmit={subirArchivo}>
                        <img alt="imagen subida" width="100%" src={profesores.archivo}></img>
                        <div class="file-field input-field">
                            <div class="btn">
                                <span>File</span>
                                <input onChange={actualizarFoto} type="file" />
                            </div>
                            <div class="file-path-wrapper">
                                <input class="file-path validate" type="text" placeholder="Upload one or more files" />
                            </div>
                        </div>
                        <div className="input-field">
                            <input onChange={leerDato} id="categoria" name='categoria' type="text" className="validate" />
                            <label for="categoria">Puesto</label>
                        </div>
                        <div className="input-field">
                            <input onChange={leerDato} id="nombre" name='nombre' type="text" className="validate" />
                            <label for="nombre">Nombre</label>
                        </div>

                        <div id='ckedittor_contenedor'>
                            <p>Materias</p>
                            
                        </div>

                        <div className='botonn_1_admin' style={{marginTop:"10px"}}>
                            <button type='submit'>
                                Agregar profesor
                            </button>
                        </div>
                    </form>
                </FormularioAgregar>
                <FormularioEditar>
                    <p className='titulo_1_admin'>Editar profesor</p>
                    {!flag ? (
                        <Loader />
                    ) : (
                        <form onSubmit={actualizarArchivo}>
                            <img alt="imagen subida" width="100%" src={profesores.archivo}></img>
                            <div class="file-field input-field">
                                <div class="btn">
                                    <span>File</span>
                                    <input onChange={agregarFoto} type="file" />
                                </div>
                                <div class="file-path-wrapper">
                                    <input class="file-path validate" type="text" placeholder="Upload one or more files" />
                                </div>
                            </div>
                            <div className="input-field">
                                <input onChange={leerDato} defaultValue={profesores.categoria} id="categoria" name='categoria' type="text" className="validate" />
                                <label className='active' for="categoria">Puesto</label>
                            </div>
                            <div className="input-field">
                                <input onChange={leerDato} defaultValue={profesores.nombre} id="nombre" name='nombre' type="text" className="validate" />
                                <label className='active' for="nombre">Nombre</label>
                            </div>

                            <div id='ckedittor_contenedor_editar'>
                                <p>Materias</p>
                                
                            </div>

                            <div className='botonn_1_admin' style={{marginTop:"10px"}}>
                                <button type='submit'>
                                    Actualizar profesor
                                </button>
                            </div>
                        </form>
                    )}
                    <div className='botonn_2_admin' style={{marginTop:"10px"}}>
                        <button onClick={eliminarArchivo}>
                            Eliminar profesor
                        </button>
                    </div>
                </FormularioEditar>
                <View/>
                
            </div>
        </Fragment>
    );
}


export default Profesores;